import React, { useState } from 'react';
import {
  Button,
  FormFeedback,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import { handleHttpError } from '@/common/http/errorHandler';
import { ClientError } from '@/common/http/errors';
import * as conditionClient from '../../../../models/companies/kyccs/conditionClient';

interface Props {
  isOpen: boolean;
  kyccId: number;
  conditionId: number;
  note: string;
  onClose: () => void;
  onChangeNote: (note: string) => void;
}

export function EditNoteModal(props: Props) {
  const { isOpen, kyccId, conditionId, onClose, onChangeNote } = props;
  const [note, setNote] = useState<string>(props.note);
  const [updating, setUpdating] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const onClickSubmit = () => {
    setUpdating(true);
    setError(null);

    conditionClient
      .updateNote(kyccId, conditionId, note)
      .then(updated => {
        if (updated.note != null) {
          onChangeNote(updated.note);
        }
      })
      .catch((error: unknown) => {
        if (
          error instanceof ClientError &&
          error.status === 422 &&
          hasNoteErrors(error.body)
        ) {
          setError(error.body.note[0]);
        } else {
          handleHttpError(error);
        }
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  const closeBtn = (
    <button className="close" onClick={onClose}>
      &times;
    </button>
  );

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalHeader toggle={onClose} close={closeBtn}>
        メモの編集
      </ModalHeader>
      <ModalBody>
        <div className="mb-4">
          <Input
            type="textarea"
            value={note}
            placeholder="30文字以内で入力してください"
            invalid={error != null}
            rows={8}
            onChange={event => setNote(event.target.value)}
          />
          {error != null && <FormFeedback>{error}</FormFeedback>}
        </div>
        <Button
          color="primary"
          size="lg"
          block
          onClick={onClickSubmit}
          disabled={updating}
        >
          保存
        </Button>
      </ModalBody>
    </Modal>
  );
}

// CSRF 失敗の HTML など、note を含まない 422 もあるため、note の配列があるときだけフィールドに出す
function hasNoteErrors(body: unknown): body is { note: string[] } {
  return (
    typeof body === 'object' &&
    body !== null &&
    'note' in body &&
    Array.isArray(body.note) &&
    body.note.length > 0
  );
}
